export const breakpoints = {
  small: 768,
  large: 992,
};

export const navigationHeights = {
  bigNavi: 80,
  smallNavi: 44,
};

export const socialShareUrls = [
  { id: 'facebook', url: 'https://facebook.com/sharer/sharer.php?u=' },
  { id: 'twitter', url: 'https://twitter.com/intent/tweet/?text=&url=' },
  { id: 'mail', url: 'mailto:?subject=&body=' },
  { id: 'pinterest', url: 'https://pinterest.com/pin/create/button/?url=' },
  {
    id: 'linkedin',
    url: 'https://www.linkedin.com/shareArticle?mini=true&url=',
  },
  { id: 'whatsapp', url: 'https://api.whatsapp.com/send?text=' },
];

export const getCountryName = (locale, code) => {
  if (!code) return null;

  const countryCode = code.toUpperCase();

  const countryNames = {
    en: {
      KR: 'Republic of Korea',
    },
    es: {
      KR: 'República de Corea',
    },
    de: {
      KR: 'Republik Korea',
    },
    kr: {
      KR: '대한민국',
    },
  };

  return (
    countryNames[locale][countryCode] ||
    new Intl.DisplayNames([locale], { type: 'region' }).of(countryCode)
  );
};

export const getLanguageName = (languageCode) => {
  return new Intl.DisplayNames(languageCode, { type: 'language' }).of(
    languageCode.toUpperCase()
  );
};

export const AWARDS = {
  IFDTA: 'iF DESIGN TALENT AWARD',
  IFDSA: 'iF DESIGN STUDENT AWARD',
  IFDSA_BEST: 'iF DESIGN STUDENT AWARD Best of the Year',
  IFDA: 'iF DESIGN AWARD',
  IFDA_GOLD: 'iF DESIGN AWARD Gold',
  IFSIP: 'iF SOCIAL IMPACT PRIZE',
};

export const IF_RANKING_PROFILE_TYPES = {
  COMPANY: 'COMPANY',
  DESIGN_AND_ARCHITECTURE_STUDIO: 'DESIGN_AND_ARCHITECTURE_STUDIO',
  INHOUSE_DESIGN_TEAM: 'INHOUSE_DESIGN_TEAM',
};

export const AWARD_IDS = {
  IFDA: 2,
  IFDA_GOLD: 9999,
  IFSIP: 5,
  IF_SIP_SUPPORTED: 8888,
  IFDSA: 1,
  IFDSA_BEST: 7777,
};

export const DEFAULT_IF_RANKING_PROFILE_TYPE = IF_RANKING_PROFILE_TYPES.COMPANY;

export const API_ROUTES = {
  PROJECT_DETAIL: '/api/entry/id',
  FIND_SUGGESTION: '/api/entry/find',
  FIND_JUROR_SUGGESTION: '/api/juror/find',
  FIND_COMPANY_SUGGESTION: '/api/company/find',
  RANDOM_COMPANIES: '/api/company/random',
  RANDOM_PROJECTS: '/api/entry/random',
  COMPANY_DETAIL: '/api/company/id',
  JUROR_DETAIL: '/api/juror/id',
  RANDOM_JUROR: '/api/juror/random',
  COLLECTION_DETAIL: '/api/collection/id',
  ENTRIES: '/api/entry/all',
  ENTRIES_FILTERS: '/api/entry/filter',
  ENTRIES_RANDOM: '/api/entry/random',
  EVENT_ICS: '/api/event/id/eventId/ics',
  ENTRIES_CATEGORIES: '/api/entry/categories',
  ENTRIES_NAVIGATION: '/api/entry/navigation',
  EVENTS: '/api/event/all',
  EVENTS_DETAIL: '/api/event/id',
  EVENTS_FILTERS: '/api/event/filter',
  EVENTS_RANDOM: '/api/event/random',
  COMPANIES: '/api/company/all',
  COMPANIES_FILTERS: '/api/company/filter',
  COMPANIES_RANDOM: '/api/company/random',
  COMPANIES_NAVIGATION: '/api/company/navigation',
  JURORS: '/api/juror/all',
  JURORS_FILTERS: '/api/juror/filter',
  JURORS_RANDOM: '/api/juror/random',
  PORTFOLIO_DETAIL: '/api/portfolio/id',
  TOP_BYCONTINENT: '/api/top/bycontinent',
  TOP_BYCOUNTRY: '/api/top/bycountry',
  RANKING: '/api/ranking',
  RANKING_FILTERS: '/api/ranking/filter',
  TRACK_SEARCH: '/api/track',
  UNPAGINATED_COMPANIES: '/api/company/all/unpaginated',
  UNPAGINATED_JURORS: '/api/juror/all/unpaginated',
  UNPAGINATED_PROJECTS: '/api/entry/all/unpaginated',
  WDI_FILTERS: '/api/top/bycountry/filter',
  SEARCH_SUGGESTION: '/api/find/',
  SEARCH_WINNER_FILTER: '/api/search/entry/filter',
  SEARCH_WINNER_DYNAMIC_FILTER: '/api/search/entry/filter/dynamic',
  SEARCH_WINNER: '/api/search/entry',
  SEARCH_WINNER_COUNT: '/api/search/entry/count',
  SEARCH_COMPANY: '/api/search/company',
  SEARCH_ARTICLE: '/api/search/article',
  SEARCH_JUROR: '/api/search/juror',
  SEARCH_RECOMMENDED: '/api/search/recommended',
  SIP: '/api/entry/sip/all',
  TALENT_JURORS: '/api/juror/talent',
  HCAPTCHA_TOKEN: '/api/captcha/token',
};

export const STATIC_ROUTES = {
  JUROR_FILTER_PAGE: '/if-design-award-and-jury/jury/overview',
  COMPANY_FILTER_PAGE: '/brands-creatives/overview',
  PROJECT_FILTER_PAGE: '/winner-ranking/winner-overview',
  SP_FILTER_PAGE: '/social-engagement/sip/winner-overview',
  STUDENT_FILTER_PAGE: '/social-engagement/student-award/winner-overview',
  EVENT_FILTER_PAGE: '/if-magazine/events/overview',
  EDITORIAL_FILTER_PAGE: '/if-magazine/editorial-filter',
  WDI_FILTER_PAGE: '/if-design-ranking',
  COMPANY_DETAIL: '/brands-creatives/company',
  PROJECT_DETAIL: '/winner-ranking/project',
  JUROR_DETAIL: '/if-design-award-and-jury/jury/profile',
  EVENT_DETAIL: '/if-magazine/events/detail',
};

export const DYNAMIC_PAGE_TYPES = {
  JURY_FILTER: 'Jury Filterlist',
  COMPANY_FILTER: 'Company Filterlist',
  PROJECT_FILTER: 'Project Filterlist',
  SP_FILTER: 'SP Filterlist',
  STUDENT_FILTER: 'Student Filterlist',
  EVENT_FILTER: 'Event Filterlist',
  COMPANY_DETAIL: 'Company Detail',
  PROJECT_DETAIL: 'Project Detail',
  JURY_DETAIL: 'Jury Detail',
  EVENT_DETAIL: 'Event Detail',
  EDITORIAL_FILTER: 'Editorial Filter',
  RANKING_FILTER: 'Ranking Filterlist',
};

export const COMPANY_RANKING_TYPES = {
  COMPANY: 'positionsCompany',
  INHOUSE_DESIGN_TEAM: 'positionsInhouse',
  DESIGN_AND_ARCHITECTURE_STUDIO: 'positionsDesign',
};
